module.exports = __webpack_public_path__ + "img/15.bb8857ae.png";